document.addEventListener('DOMContentLoaded', () => {
  // Auto-assign staggered animation index --i to child items in grid/list containers
  const staggerParents = document.querySelectorAll(
    /* videos track excluded: .fu transform fights carousel translate/scale */
    '.homland-prod-grid, .hl-col-cat-resources__grid, .ac-inner, .wcus-grid, .fu-group, .hl-stagger-parent'
  );
  staggerParents.forEach(parent => {
    Array.from(parent.children).forEach((child, index) => {
      child.style.setProperty('--i', index);
      if (!child.classList.contains('fu') && !child.classList.contains('hl-reveal')) {
        child.classList.add('fu');
      }
    });
  });

  // IntersectionObserver for scroll reveal animations
  const obs = new IntersectionObserver(
    entries => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          e.target.classList.add('vis');
          obs.unobserve(e.target);
        }
      });
    },
    { threshold: 0.08, rootMargin: '0px 0px -40px 0px' }
  );

  document.querySelectorAll('.fu, .hl-reveal').forEach(el => obs.observe(el));
});